<h1>AI Processing Disclosure</h1>

<p>This app securely sends certain data to third-party AI providers, including OpenAI and Amazon Web Services (AWS) AI
	for processing. This includes audio recordings of clinical encounters. </p>

<p>This information is used solely to generate documentation and support the functionality of the app. By continuing,
	you acknowledge and consent to the transmission of this information to our AI service providers as described in <a
		href="https://allaihealth.com/app-privacy-policy/" target="_blank">AllaiHealth’s Privacy Policy.</a></p>

<div class="actions">
	<a href="https://allaihealth.com/app-privacy-policy/" target="_blank" mat-button>
		<div>
			<span>Learn More</span>
			<mat-icon inline="true">open_in_new</mat-icon>
		</div>
	</a>
	<button mat-flat-button color="primary" (click)="agree()">I Agree</button>
</div>
